import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { EventDetails } from './pages/EventDetails';
import { BookingDetails } from './pages/BookingDetails';
import { BookingConfirmation } from './pages/BookingConfirmation';
import { GuestRequests } from './pages/GuestRequests';
import { Bookings } from './pages/Bookings';
import { Messages } from './pages/Messages';
import { Conversation } from './pages/Conversation';
import { Profile } from './pages/Profile';
import { LoginPage } from './pages/LoginPage';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<LoginPage data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<ProtectedRoute data-id="element-6">
                <Home data-id="element-7" />
              </ProtectedRoute>} data-id="element-5" />
          <Route path="/event/:id" element={<ProtectedRoute data-id="element-9">
                <EventDetails data-id="element-10" />
              </ProtectedRoute>} data-id="element-8" />
          <Route path="/booking/:eventId/:tableId" element={<ProtectedRoute data-id="element-12">
                <BookingDetails data-id="element-13" />
              </ProtectedRoute>} data-id="element-11" />
          <Route path="/booking-confirmation/:eventId/:tableId" element={<ProtectedRoute data-id="element-15">
                <BookingConfirmation data-id="element-16" />
              </ProtectedRoute>} data-id="element-14" />
          <Route path="/guest-requests/:bookingId" element={<ProtectedRoute data-id="element-18">
                <GuestRequests data-id="element-19" />
              </ProtectedRoute>} data-id="element-17" />
          <Route path="/bookings" element={<ProtectedRoute data-id="element-21">
                <Bookings data-id="element-22" />
              </ProtectedRoute>} data-id="element-20" />
          <Route path="/messages" element={<ProtectedRoute data-id="element-24">
                <Messages data-id="element-25" />
              </ProtectedRoute>} data-id="element-23" />
          <Route path="/conversation/:id" element={<ProtectedRoute data-id="element-27">
                <Conversation data-id="element-28" />
              </ProtectedRoute>} data-id="element-26" />
          <Route path="/profile" element={<ProtectedRoute data-id="element-30">
                <Profile data-id="element-31" />
              </ProtectedRoute>} data-id="element-29" />
          <Route path="*" element={<Navigate to="/login" replace data-id="element-33" />} data-id="element-32" />
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}